import React from 'react'
import { Navbar, Nav } from 'react-bootstrap'
export default function NavbarC() {


    const scrollToMyCode = () => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        })
    }
    const breif = () => {
        window.scroll({
            top: 900,
            behavior: 'smooth'
        })
    }
    const skills = () => {
        window.scroll({
            top: 1800,
            behavior: 'smooth'
        })
    }
    const code = () => {
        window.scroll({
            top: 3000,
            behavior: 'smooth'
        })
    }
    const contact = () => {
        window.scroll({
    top:3200,
            behavior: 'smooth'
        })
    }
    return (

        <Navbar collapseOnSelect expand="lg" fixed="top py-0 " bg="black" variant="dark">
            <Navbar.Toggle aria-controls="responsive-navbar-nav " />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto">
                    <Nav.Link href="#home"
                        onClick={scrollToMyCode}>Home
                </Nav.Link>
                    <Nav.Link href="#home"
                        onClick={breif}>Breif
            </Nav.Link>
                    <Nav.Link href="#home"
                        onClick={skills}>Works
            </Nav.Link>

                    <Nav.Link href="#features" onClick={code}>About</Nav.Link>
                    <Nav.Link href="#pricing" onClick={scrollToMyCode}>Contact</Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>

    )
}
